// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__KYY4n","title":"BackImages_title__24hvw","images":"BackImages_images__3VH2u"};